// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__Z903M","initials":"styles_initials__kKBx2"};